import { render, staticRenderFns } from "./edito-banner.vue?vue&type=template&id=47205ad9"
import script from "./edito-banner.vue?vue&type=script&lang=js"
export * from "./edito-banner.vue?vue&type=script&lang=js"
import style0 from "./edito-banner.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PatternsBadgePill: require('/home/node/app/components/patterns/badge-pill/badge-pill.vue').default,ElementsUiWrapper: require('/home/node/app/components/elements/ui-wrapper/ui-wrapper.vue').default})
